import { useCallback, useMemo } from 'react'
import ROUTES from 'src/constants/routes'
import { useAuth } from 'src/contexts/auth'
import { usePermissions } from 'src/hooks/auth/usePermissions'
import { useGetPendingRecordList } from 'src/hooks/api/record'

import {
  CowBoyIcon,
  GraphicIcon,
  skullCow,
  Coverage,
  Planning,
  Genotyping,
  Sales,
  geneticEvalationIcon,
  CowIcon,
  SettingIcon,
  Graphic2Icon,
  VaccinesIcon
} from 'src/assets/svg'

// import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck'

import {
  BarChartRounded,
  Group,
  GridOn,
  LocalHospital,
  Place,
  CropFree,
  Assessment,
  ListAlt
} from '@material-ui/icons'

import { MovimentationIcon, WeighingIcon } from 'src/assets/png'

export const useSideMenu = () => {
  const { logout, name, profile } = useAuth()
  const { getMenuItems } = usePermissions()

  const { data: pendingRecords } = useGetPendingRecordList({ status: 'Aguardando' }, 'get-pending-records-side-menu')

  // 🔹 Total de pendências
  const pendingRecordCount = useMemo(() => {
    return pendingRecords?.pages?.[0]?.total ?? 0
  }, [pendingRecords])

  // 🔹 Ícones por rota
  const iconMap = useMemo(
    () => ({
      [ROUTES.DASHBOARD]: GridOn,
      // [ROUTES.ADMIN.RECORD_VALIDATION]: PlaylistAddCheckIcon,
      [ROUTES.ANIMAL.ROOT]: CowIcon,
      [ROUTES.DEATHS_AND_DISEASES]: skullCow,
      [ROUTES.REPRODUCTION.ROOT]: Coverage,
      [ROUTES.REPRODUCTION.COVERAGE_PROCESS.ROOT]: Coverage,
      [ROUTES.REPRODUCTION.PREGNANCY_DIAGNOSIS]: BarChartRounded,
      [ROUTES.REPRODUCTION.BIRTH_REGISTRATION]: CowIcon,
      [ROUTES.REPRODUCTION.PREGNANCY_LIST]: Graphic2Icon,
      [ROUTES.REPRODUCTION.COVERAGE_PROCESS.NEW]: SettingIcon,
      [ROUTES.COUPLE_PLANNING.ROOT]: Planning,
      [ROUTES.GENETICS.GENOTYPING]: Genotyping,
      [ROUTES.GENETICS.EVALUATION]: geneticEvalationIcon,
      [ROUTES.ADMIN.SALES]: Sales,
      [ROUTES.ADMIN.PROPERTIES]: GridOn,
      [ROUTES.ADMIN.ANCP]: GridOn,
      [ROUTES.ADMIN.USERS]: Group,
      [ROUTES.ADMIN.VACCINE]: LocalHospital,
      [ROUTES.LOCATIONS.ROOT]: Place,
      [ROUTES.ADMIN.LOTS]: CropFree,
      [ROUTES.ADMIN.REPORTS]: Assessment,
      [ROUTES.HERD_MANAGEMENT.ROOT]: CowBoyIcon,
      [ROUTES.HERD_MANAGEMENT.WEIGHTING]: WeighingIcon,
      [ROUTES.HERD_MANAGEMENT.MOVIMENTATION]: MovimentationIcon,
      [ROUTES.HERD_MANAGEMENT.HEALTH_CONTROL]: VaccinesIcon,
      [ROUTES.BIRTH_FORM.ROOT]: ListAlt,

      [ROUTES.HOLE_PROCESS]: BarChartRounded
    }),
    []
  )

  // 🔹 Menu lateral final
  const menus = useMemo(() => {
    return getMenuItems()
      .filter((item) => item.isMenuSideBar)
      .map((item) => ({
        ...item,
        icon: item.icon || iconMap[item.path],
        // stickyValue:
        //   item.path === ROUTES.ADMIN.RECORD_VALIDATION && pendingRecordCount > 0 ? pendingRecordCount : undefined,
        children: item.children?.map((child) => ({
          ...child,
          icon: child.icon || iconMap[child.path]
        }))
      }))
  }, [getMenuItems, iconMap, pendingRecordCount])

  const userLogged = useMemo(
    () => [
      {
        letra: name?.[0],
        user: name,
        type: profile
      }
    ],
    [name, profile]
  )

  const handleLogout = useCallback(() => {
    logout()
  }, [logout])

  return {
    profile,
    userLogged,
    menus,
    handleLogout
  }
}
